export enum MedicineSelectOption {
  HandMedicineEntry = "handMedicineEntry",
}
